import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import { userSelector } from 'selectors/user/userSelector';
import RecommendationsServiceActions from 'actions/RecommendationsServiceActions.js';
import { recommendationsServiceSelector } from 'selectors/recommendationsService/recommendationsServiceSelector';
import { isAnonymousSelector } from 'selectors/auth/isAnonymousSelector';
import Empty from 'constants/empty';
import { customerPreferenceSelector } from 'selectors/user/customerPreferenceSelector';
import BeautyPreferencesActions from 'actions/BeautyPreferencesActions';
import bpRedesignedUtils from 'utils/BeautyPreferencesRedesigned';

const { wrapHOC } = FrameworkUtils;
const { openPrivacySettingsModal, closePrivacySettingsModal } = BeautyPreferencesActions;

const fields = createSelector(
    userSelector,
    recommendationsServiceSelector,
    isAnonymousSelector,
    customerPreferenceSelector,
    (user, recommendationsService, isAnonymous) => {
        const customerPreference = user.customerPreference || Empty.Object;
        const biAccount = user.beautyInsiderAccount || Empty.Object;
        const isAtLeastOneAnswered = Object.keys(customerPreference).some(worldKey =>
            bpRedesignedUtils.isAtLeastOneAnsweredForWorld(customerPreference, worldKey)
        );

        return {
            customerPreference,
            recommendations: recommendationsService.recommendations,
            isAnonymous,
            biAccount,
            user,
            isAtLeastOneAnswered
        };
    }
);

const functions = {
    fetchRecommendations: payload => RecommendationsServiceActions.fetchRecommendations(payload),
    openPrivacySettingsModal,
    closePrivacySettingsModal
};

const withBeautyPreferencesProps = wrapHOC(connect(fields, functions));

export {
    fields, functions, withBeautyPreferencesProps
};
